export default __webpack_public_path__ + "static/media/PricingPage.1249e8cb.jpeg";